











import VueBase from '@/components/VueBase';
import { Component, Prop } from 'vue-property-decorator';
import { RawLocation } from 'vue-router';
import { UserState, RequestResult, MsalService, SettingsHelper } from '@questelservices/common';

// TODO: Move custom hooks to main.ts when used beyond this component
Component.registerHooks([
    'beforeRouteEnter',
    'beforeRouteLeave',
    'beforeRouteUpdate' // for vue-router 2.2+
]);

@Component({})
export default class ActiveDirectoryLogin extends VueBase {
    @Prop({ required: true })
    public productName!: string;

    protected readonly defaultErrorMessage: string = 'An error occurred during login. Please refresh the page and try again, or contact support if it persists.';
    protected errorMessage: string = '';
    protected isRecoverySuccessful: boolean = false;
    protected apiRequestActive: boolean = false;
    protected msalService: MsalService = new MsalService(this.$store);
    protected readonly baseApiRoute: string = '/api/v1';

    constructor() {
        super();
    }

    public beforeRouteUpdate(to: any, from: any, next: any): void {
        this.errorMessage = '';
        next();
    }

    protected async initializeAuthUrl(): Promise<void> {
        try {
            let authUrl: string = await SettingsHelper.getAuthenticationUrl(this.baseApiRoute);
            await this.commonModule.setAuthenticationUrl(authUrl);
        } catch (error) {
            console.log(error);
        }
    }

    protected async mounted() {
        this.apiRequestActive = true;
        await this.initializeAuthUrl();
        // Skip all the ActiveDirectory login when the user is already authenticated
        const user: UserState = this.commonModule.authenticatedUser;
        debugger;
        if (!!user && user.authenticated == true && user.isAdLogin == true) {
            const redirectUrl: string = this.$router.currentRoute.query.redirect as string;
            let redirectTo: string = redirectUrl ? redirectUrl : '/';

            this.$router.push(redirectTo);
        }
        else {
            await this.login();
        }
    }

    private async login(): Promise<void> {
        this.apiRequestActive = true;

        try {
            const state = JSON.stringify({
                redirect: this.$router.currentRoute.query.redirect
            });

            const resultState = await this.msalService.acquireADToken(this.productName, state, this.baseApiRoute);
            debugger;
            await this.loginSuccess(resultState);
        }
        catch (error) {
            this.requestFailure(error, 'Azure Login');
        }
    }

    private async loginSuccess(state?: any): Promise<any> {
      debugger;
        await this.commonModule.setSessionTimeoutRedirectUrl({ name: 'employee' });
        this.$root.$emit('login-success');

        if (this.$router.currentRoute.query.redirect || (state && state.redirect)) {
            const redirectTo = this.$router.currentRoute.query.redirect ?? state.redirect;
            this.$router.push(redirectTo as RawLocation);
        } else {
            this.$router.push('/');
        }
    }

    private requestFailure(result: RequestResult, supportInfo?: string): void {
      debugger;
        // Log details for troublshooting.
        console.groupCollapsed('Active Directory login failed.')
        console.dir(result);
        console.groupEnd();

        this.errorMessage = this.defaultErrorMessage;

        if (supportInfo != null) {
            this.errorMessage += `<br /><br />Support Info: ${supportInfo}`;
        }

        this.apiRequestActive = false;
    }
}
